import {
    validateFormAction,
} from '../actions/validateForm';
import * as types from './types';

function setSeatInfo(seatInfo) {
    return {
        payload: seatInfo,
        type: types.SET_SEAT_INFO,
    };
}

function setBookingSessionId(bookingSessionId) {
    return {
        payload: bookingSessionId,
        type: types.SET_BOOKING_SESSION_ID,
    };
}

function setBookingForm(bookingForm) {
    return {
        payload: bookingForm,
        type: types.SET_BOOKING_FORM,
    };
}

function setDetails(details) {
    return {
        payload: details,
        type: types.SET_DETAILS,
    };
}

function setPayment(payment) {
    return {
        payload: payment,
        type: types.SET_PAYMENT,
    };
}

function setPaymentMethods(paymentMethods) {
    return {
        payload: paymentMethods,
        type: types.SET_PAYMENT_METHODS,
    };
}

function setValidations(validations) {
    return {
        payload: validations,
        type: types.SET_VALIDATIONS,
    };
}

function setLocalities(localities) {
    return {
        payload: localities,
        type: types.SET_LOCALITIES,
    };
}

function setBookingInfo(bookingInfo) {
    return {
        payload: bookingInfo,
        type: types.SET_BOOKING_INFO,
    };
}

function resetBookingInfo() {
    return {
        type: types.RESET_BOOKING_INFO,
    };
}

function setQuoteSummary(quoteSummary) {
    return {
        payload: quoteSummary,
        type: types.SET_QUOTE_SUMMARY,
    };
}

function setFieldValueHelper(path, value) {
    return {
        payload: { path, value },
        type: types.SET_FIELD_VALUE,
    };
}

function setFieldValue(path, value, validate = true) {
    return (dispatch) => {
        dispatch(setFieldValueHelper(path, value));

        if (validate) {
            dispatch(validateFormAction.validate());
        }
    };
}

function resetFieldValue(path, validate = true) {
    return (dispatch) => {
        dispatch({
            payload: path,
            type: types.RESET_FIELD_VALUE,
        });

        if (validate) {
            dispatch(validateFormAction.validate());
        }
    };
}

function setFieldOptionsByType(path, options) {
    return {
        payload: { options, path },
        type: types.SET_FIELD_OPTIONS_BY_TYPE,
    };
}

function setFieldOptionsByPath(path, values) {
    return {
        payload: { path, values },
        type: types.SET_FIELD_OPTIONS_BY_PATH,
    };
}

function setProcessingId(tripId, processingId) {
    return {
        meta: tripId,
        payload: processingId,
        type: types.SET_PROCESSING_ID,
    };
}

function setBookingStatus(processingId, bookingStatus) {
    return {
        meta: processingId,
        payload: bookingStatus,
        type: types.SET_BOOKING_STATUS,
    };
}

function resetBookingStatus() {
    return {
        type: types.RESET_BOOKING_STATUS,
    };
}

function setInsuranceProcessingId(tripId, insuranceProcessingId) {
    return {
        meta: tripId,
        payload: insuranceProcessingId,
        type: types.SET_INSURANCE_PROCESSING_ID,
    };
}

function setInsuranceStatus(insuranceStatus) {
    return {
        payload: insuranceStatus,
        type: types.SET_INSURANCE_STATUS,
    };
}

function resetInsuranceStatus() {
    return {
        type: types.RESET_INSURANCE_STATUS,
    };
}

function setTripConfirmation(tripId, confirmation) {
    return {
        meta: tripId,
        payload: confirmation,
        type: types.SET_TRIP_CONFIRMATION,
    };
}

function resetTripConfirmations() {
    return {
        type: types.RESET_TRIP_CONFIRMATIONS,
    };
}

function setInsuranceSelected(isInsuranceSelected) {
    return {
        payload: isInsuranceSelected,
        type: types.SET_INSURANCE_SELECTED,
    };
}

function resetInsuranceSelected() {
    return {
        type: types.RESET_INSURANCE_SELECTED,
    };
}

function setAccountExists({ userAccountExists, userEmail }) {
    return {
        payload: {
            userAccountExists,
            userEmail,
        },
        type: types.SET_ACCOUNT_EXISTS,
    };
}

function setFieldValidation(path, value) {
    return {
        payload: { path, value },
        type: types.SET_FIELD_VALIDATION,
    };
}

function setGoogleDepartId(id) {
    return {
        payload: id,
        type: types.SET_GOOGLE_DEPART_ID,
    };
}

function setGoogleDestinationId(id) {
    return {
        payload: id,
        type: types.SET_GOOGLE_DESTINATION_ID,
    };
}

function resetGooglePlaceIds() {
    return {
        type: types.RESET_GOOGLE_PLACE_IDS,
    };
}

function setAllFieldsModified() {
    return {
        type: types.SET_ALL_FIELDS_AS_MODIFIED,
    };
}

function setFieldsModified(fields) {
    return {
        payload: { fields },
        type: types.SET_FIELDS_AS_MODIFIED,
    };
}

export {
    resetBookingInfo,
    resetBookingStatus,
    resetFieldValue,
    resetGooglePlaceIds,
    resetInsuranceSelected,
    resetInsuranceStatus,
    resetTripConfirmations,
    setAccountExists,
    setAllFieldsModified,
    setBookingForm,
    setBookingInfo,
    setBookingSessionId,
    setBookingStatus,
    setDetails,
    setFieldOptionsByPath,
    setFieldOptionsByType,
    setFieldValidation,
    setFieldValue,
    setFieldValueHelper,
    setFieldsModified,
    setGoogleDepartId,
    setGoogleDestinationId,
    setInsuranceProcessingId,
    setInsuranceSelected,
    setInsuranceStatus,
    setLocalities,
    setProcessingId,
    setPayment,
    setPaymentMethods,
    setQuoteSummary,
    setSeatInfo,
    setTripConfirmation,
    setValidations,
};
